export default "__VITE_ASSET__Buzwf_zU__"